import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { House, ClockCounterClockwise, GearSix, SignOut, Trophy } from "@phosphor-icons/react";
import { clearAuth, getUser } from "../lib/api";

export default function Shell({ children, title, hideNav = false, rightSlot = null }) {
  const loc = useLocation();
  const nav = useNavigate();
  const user = getUser();

  const onLogout = () => {
    clearAuth();
    nav("/login");
  };

  const tab = (path, Icon, label, testid) => {
    const active = loc.pathname === path || (path !== "/app" && loc.pathname.startsWith(path));
    return (
      <Link
        to={path}
        data-testid={testid}
        className={`flex flex-col items-center justify-center gap-0.5 py-2 px-2 rounded-2xl transition-all flex-1 ${
          active ? "text-brand-ink" : "text-brand-ink2/60"
        }`}
      >
        <Icon size={22} weight={active ? "fill" : "duotone"} />
        <span className="text-[10px] font-nunito font-semibold">{label}</span>
      </Link>
    );
  };

  return (
    <div className="app-shell w-full max-w-md mx-auto min-h-[100dvh] flex flex-col relative" data-testid="app-shell">
      <header className="sticky top-0 z-30 bg-brand-paper/90 backdrop-blur border-b border-black/5 px-5 py-4 flex items-center justify-between">
        <div>
          <div className="font-outfit font-extrabold text-lg leading-none text-brand-ink">Ödevix</div>
          {title && <div className="font-nunito text-xs text-brand-ink2 mt-1">{title}</div>}
        </div>
        <div className="flex items-center gap-2">
          {rightSlot}
          {user && (
            <button onClick={onLogout} data-testid="logout-button" className="p-2 rounded-full hover:bg-brand-paperAlt" title="Çıkış">
              <SignOut size={20} weight="duotone" />
            </button>
          )}
        </div>
      </header>

      <main className="flex-1 px-5 pt-4 pb-28">{children}</main>

      {!hideNav && (
        <nav className="fixed bottom-3 left-1/2 -translate-x-1/2 w-[94%] max-w-md bg-white shadow-[0_10px_30px_rgba(29,53,87,0.15)] rounded-3xl flex items-center justify-around py-1 border border-black/5 z-40">
          {tab("/app", House, "Ana Sayfa", "tab-home")}
          {tab("/app/achievements", Trophy, "Başarılar", "tab-achievements")}
          {tab("/app/history", ClockCounterClockwise, "Geçmiş", "tab-history")}
          {tab("/app/settings", GearSix, "Ayarlar", "tab-settings")}
        </nav>
      )}
    </div>
  );
}
